// extracted by mini-css-extract-plugin
export var button = "_dg-4";
export var hasDarkBackground = "_dg-7";
export var hasLightBackground = "_dg-6";
export var iconWrapper = "_dg-0";
export var large = "_dg-2";
export var medium = "_dg-1";
export var small = "_dg-5";
export var xsmall = "_dg-3";